import { useEffect, useRef } from "react";

const AUTO_LOGOUT_TIME = 8 * 60 * 60 * 1000; // 8 hours in milliseconds
const LAST_ACTIVITY_KEY = "lastActivityTime";

const useAutoLogout = (onLogout) => {
  const timeoutRef = useRef(null);

  const resetTimer = () => {
    const now = Date.now();
    localStorage.setItem(LAST_ACTIVITY_KEY, now.toString());

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      onLogout();
    }, AUTO_LOGOUT_TIME);
  };

  const handleActivity = () => {
    resetTimer();
  };

  useEffect(() => {
    // On load, check if user has been inactive already
    const lastActivity = parseInt(
      localStorage.getItem(LAST_ACTIVITY_KEY) || "0",
      10
    );

    const now = Date.now();

    if (lastActivity && now - lastActivity > AUTO_LOGOUT_TIME) {
      onLogout();
      localStorage.setItem("logout", Date.now().toString()); // notify other tabs
      return;
    }

    resetTimer(); // Start the timer on mount

    window.addEventListener("mousemove", handleActivity);
    window.addEventListener("keydown", handleActivity);
    window.addEventListener("mousedown", handleActivity);
    window.addEventListener("touchstart", handleActivity);
    window.addEventListener("scroll", handleActivity);
    window.addEventListener("wheel", handleActivity);

    const onStorageChange = (e) => {
      if (e.key === "logout") {
        // Another tab triggered logout
        onLogout();
      }
    };

    window.addEventListener("storage", onStorageChange);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      window.removeEventListener("mousemove", handleActivity);
      window.removeEventListener("keydown", handleActivity);
      window.removeEventListener("mousedown", handleActivity);
      window.removeEventListener("touchstart", handleActivity);
      window.removeEventListener("scroll", handleActivity);
      window.removeEventListener("wheel", handleActivity);
      window.removeEventListener("storage", onStorageChange);
    };
  }, []);
};

export default useAutoLogout;
